import React, { useState, useEffect } from "react";
import { Box, Button, Spinner, useMediaQuery } from "@chakra-ui/react";
import {
  Tabs,
  TabList,
  TabPanels,
  Tab,
  TabPanel,
  useToast,
} from "@chakra-ui/react";
import { RepeatIcon } from "@chakra-ui/icons";
import axios from "axios";

import KTTableauMIX from "../../../Components/EmbedKT/KTTableauMIX";
import KTTableauHourly from "../../../Components/EmbedKT/KTTableauHourly";
import KTTableauWeekly from "../../../Components/EmbedKT/KTTableauWeekly";
import KTTableauTender from "../../../Components/EmbedKT/KTTableauTender";
import KTTableauChannel from "../../../Components/EmbedKT/KTTableauChannel";
import KTTableauDSR from "../../../Components/EmbedKT/KTTableauDSR";
import KTTableauNPS from "../../../Components/EmbedKT/KTTableauNPS";

import KTTableauMIXM from "../../../Components/EmbedKT/MobileView/KTTableauMIXM";
import KTTableauHourlyM from "../../../Components/EmbedKT/MobileView/KTTableauHourlyM";
import KTTableauWeeklyM from "../../../Components/EmbedKT/MobileView/KTTableauWeeklyM";
import KTTableauTenderM from "../../../Components/EmbedKT/MobileView/KTTableauTenderM";
import KTTableauChannelM from "../../../Components/EmbedKT/MobileView/KTTableauChannelM";
import KTTableauDSRM from "../../../Components/EmbedKT/MobileView/KTTableauDSRM";
import KTTableauNPSM from "../../../Components/EmbedKT/MobileView/KTTableauNPSM";

const KTReports = ({ content }) => {
  const [isSmallerThan600] = useMediaQuery("(max-width: 600px)");
  const [refreshPage, setRefreshPage] = useState(false);
  const [loading, setLoading] = useState(false);
  const [firstLoad, setFirstLoad] = useState(true);
  const [key, setKey] = useState(Date.now());
  const toast = useToast();

  const handleRefreshTokenTableauButton = async () => {
    try {
      setLoading(true);
      const resJWTTableau = await axios.get(
        `${process.env.REACT_APP_BACKEND_API_URL}/generatejwt`,
        { withCredentials: true },
      );
      localStorage.setItem("tableauToken", resJWTTableau.data);
      setRefreshPage((prev) => !prev);
      setKey(Date.now());
      setLoading(false);
    } catch (err) {
      setLoading(false);
      toast({
        title: "Error",
        position: "top-right",
        description: err.response?.data?.message || "Failed to refresh token.",
        status: "error",
        duration: 9000,
        isClosable: true,
      });
    }
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      setFirstLoad(false);
    }, 1000 * 3);

    return () => clearTimeout(timer);
  }, [refreshPage]);

  return (
    <>
      <div key={key}>
        <Box mt={4} mb={2}>
          <Button
            colorScheme="red"
            onClick={handleRefreshTokenTableauButton}
            isDisabled={loading}
          >
            {loading ? (
              <Spinner />
            ) : (
              <>
                Refresh <RepeatIcon marginLeft={2} />
              </>
            )}
          </Button>
        </Box>
        <Tabs isFitted variant="enclosed">
          <TabList
            mb="1em"
            style={{
              overflowX: "auto",
              whiteSpace: "nowrap",
              scrollbarWidth: "none",
              msOverflowStyle: "none",
            }}
          >
            <Tab _selected={{ color: "white", bg: "red.600" }}>Product Mix</Tab>
            <Tab _selected={{ color: "white", bg: "red.600" }}>Hourly</Tab>
            <Tab _selected={{ color: "white", bg: "red.600" }}>Weekly</Tab>
            <Tab _selected={{ color: "white", bg: "red.600" }}>Tender</Tab>
            <Tab _selected={{ color: "white", bg: "red.600" }}>Channel</Tab>
            <Tab _selected={{ color: "white", bg: "red.600" }}>DSR</Tab>
            <Tab _selected={{ color: "white", bg: "red.600" }}>NPS</Tab>
          </TabList>
          <TabPanels
            height={{
              base: "100%",
              md: "50%",
              xl: "25%",
            }}
            width="100%"
            m={0}
            p={0}
          >
            <TabPanel m={0} p={0}>
              {firstLoad ? (
                <Spinner size={"xl"} mt={20} />
              ) : isSmallerThan600 ? (
                <KTTableauMIXM />
              ) : (
                <KTTableauMIX />
              )}
            </TabPanel>
            <TabPanel m={0} p={0}>
              {firstLoad ? (
                <Spinner size={"xl"} mt={20} />
              ) : isSmallerThan600 ? (
                <KTTableauHourlyM />
              ) : (
                <KTTableauHourly />
              )}
            </TabPanel>
            <TabPanel m={0} p={0}>
              {firstLoad ? (
                <Spinner size={"xl"} mt={20} />
              ) : isSmallerThan600 ? (
                <KTTableauWeeklyM />
              ) : (
                <KTTableauWeekly />
              )}
            </TabPanel>
            <TabPanel m={0} p={0}>
              {firstLoad ? (
                <Spinner size={"xl"} mt={20} />
              ) : isSmallerThan600 ? (
                <KTTableauTenderM />
              ) : (
                <KTTableauTender />
              )}
            </TabPanel>
            <TabPanel m={0} p={0}>
              {firstLoad ? (
                <Spinner size={"xl"} mt={20} />
              ) : isSmallerThan600 ? (
                <KTTableauChannelM />
              ) : (
                <KTTableauChannel />
              )}
            </TabPanel>
            <TabPanel m={0} p={0}>
              {firstLoad ? (
                <Spinner size={"xl"} mt={20} />
              ) : isSmallerThan600 ? (
                <KTTableauDSRM />
              ) : (
                <KTTableauDSR />
              )}
            </TabPanel>
            <TabPanel m={0} p={0}>
              {firstLoad ? (
                <Spinner size={"xl"} mt={20} />
              ) : isSmallerThan600 ? (
                <KTTableauNPSM />
              ) : (
                <KTTableauNPS />
              )}
            </TabPanel>
          </TabPanels>
        </Tabs>
      </div>
    </>
  );
};

export default KTReports;
